import { ComponentPropsWithoutRef } from 'react';

export type TableHeadProps = ComponentPropsWithoutRef<'th'>;

export const TableHead = (props: TableHeadProps) => <th {...props} />;
